import { atom } from "recoil";

export type ReceiptModalType = {
  visibleConfirm: boolean;
  handleConfirm?: any;
  modalData: any;
};

export const receiptModalState = atom<ReceiptModalType>({
  key: "receiptModal",
  default: {
    visibleConfirm: false,
    modalData: [],
  },
});
